<section class="wr" [class.wr--mobile]="isMobileView" [class.is-open]="revealed">
  <!-- Rotating spotlight behind the card -->
  <div class="wr-rays" aria-hidden="true"></div>
  <div class="wr-halo" aria-hidden="true"></div>

  <div class="wr-card">
    <!-- A <div> rather than a <button>: the global button theme would repaint it. -->
    <div class="wr-close" role="button" tabindex="0" aria-label="Close"
         (click)="close()" (keydown.enter)="close()" (keydown.space)="close()">&times;</div>

    <div class="wr-sparks" aria-hidden="true">
      <span *ngFor="let s of sparks" [style.left.%]="s.left" [style.top.%]="s.top"
            [style.animation-delay.ms]="s.delay" [style.width.px]="s.size" [style.height.px]="s.size"></span>
    </div>

    <p class="wr-event" *ngIf="data.WebinarName">{{ data.WebinarName }}</p>

    <div class="wr-crest">
      <span class="wr-crest-icon" aria-hidden="true">🏆</span>
      <span class="wr-crest-text">Winner</span>
    </div>

    <div class="wr-prize" *ngIf="data.ItemImageUrl && !imageFailed">
      <div class="wr-prize-ring" aria-hidden="true"></div>
      <img [src]="data.ItemImageUrl" alt="Prize" class="wr-prize-img" (error)="onImageError()">
    </div>

    <p class="wr-congrats">Congratulations</p>
    <h2 class="wr-name">{{ displayName }}</h2>

    <div class="wr-seat">
      <span class="wr-seat-label">Seat</span>
      <span class="wr-seat-num">{{ data.SeatNumber }}</span>
    </div>

    <p class="wr-line">has been drawn as the winner</p>

    <div class="wr-rule" aria-hidden="true"></div>

    <p class="wr-note">We'll be in touch about getting your prize to you.</p>
  </div>
</section>
